import MuiPagination, { PaginationProps } from '@mui/material/Pagination'
import PaginationItem from '@mui/material/PaginationItem'
import Link from 'next/link'
import { useRouter } from 'next/router'
import React from 'react'

const LinkComponent: React.FC<{ href: URL; [key: string]: unknown }> = ({ href, ...rest }) => {
  return <Link href={href} prefetch {...rest}></Link>
}

interface iPaginationProps extends Omit<PaginationProps, 'renderItem' | 'page'> {}

const Pagination: React.FC<iPaginationProps> = ({ ...props }) => {
  const router = useRouter()

  return (
    <MuiPagination
      {...props}
      page={parseInt(router.query?.page as string) || 1}
      renderItem={item => {
        if (item.page && item.page < 0) return null
        return (
          <PaginationItem
            component={LinkComponent}
            href={{
              pathname: router.pathname,
              query: {
                ...router.query,
                page: item.page
              }
            }}
            {...item}
          />
        )
      }}
    />
  )
}

export default Pagination
